module.exports = __webpack_public_path__ + "media/assets/site_images/partner_logos/pgd_logo-5990f20c22c9ada1cb7743220b3bb14f.png";